import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  dashBoardData1,
  dashBoardData2,
  dashBoardData3,
  dashBoardData4,
  getAllCapabilities,
} from "../../../../services/webServices";

import ReactECharts from "echarts-for-react";

const TopServicesChart = () => {
  const [chartData, setChartData] = useState({});
  const [fromDate1, setFromDate1] = useState("");
  const [toDate1, setToDate1] = useState("");

  const processChartData = (data) => {
    const capabilities = data.dashboardData.map((item) => item.capability_name);
    const usageCounts = data.dashboardData.map((item) =>
      parseInt(item.usage_count)
    );

    const staticColors = [
      "#FF5733",
      "#28A745",
      "#3357FF",
      "#FF33A1",
      "#F1C40F",
      "#8E44AD",
      "#3498DB",
      "#E67E22",
    ];

    setChartData({
      tooltip: {
        trigger: "item",
        formatter: (params) => `${params.name}: ${params.value}`,
      },
      xAxis: {
        type: "category",
        data: capabilities, // capability names
        axisLabel: {
          fontSize: 10,
          interval: 0, // Show all labels
          rotate: 15, // Slight rotation
        },
        axisTick: {
          show: false,
        },
        // name: "Capabilities",
      },

      yAxis: {
        type: "value",
        axisLabel: { fontSize: 12 },
        name: "Usage Count",
        nameLocation: "center",
        nameGap: 55,
      },
      grid: {
        left: "6%",
        right: "4%",
        bottom: "3%",
        top: "15%",
        containLabel: true,
      },
      series: [
        {
          data: usageCounts,
          type: "bar",
          barWidth: "20%",
          itemStyle: {
            color: (params) =>
              staticColors[params.dataIndex % staticColors.length],
            borderRadius: [4, 4, 0, 0],
          },
          emphasis: {
            itemStyle: {
              opacity: 0.8,
            },
          },
        },
      ],
    });
  };

  useEffect(() => {
    const dates1 = { fromDate1, toDate1 };
    dashBoardData1(dates1)
      .then((response) => processChartData(response.data))
      .catch((error) => console.error("Error fetching dashboard data:", error));
  }, [fromDate1, toDate1]);

  // const handleFilterGraph1 = async () => {
  //   try {
  //     const dates1 = { fromDate1, toDate1 };
  //     const response = await dashBoardData1(dates1);
  //     processChartData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  return (
    <Card sx={{ maxWidth: "721px", minHeight: "470px", height: "560px" }}>
      <div className="chart-wrapper">
        <CardContent>
          <Typography variant="h6">
            Top 5 capabilities
            <span
              style={{
                fontSize: "0.85rem",
                marginLeft: "8px",
                color: "#9C9C9C",
                fontWeight: "bold",
              }}
            >
              User Activity
            </span>
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <TextField
              label="From"
              variant="outlined"
              margin="normal"
              type="date"
              value={fromDate1}
              onChange={(e) => setFromDate1(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ width: "30%" }}
            />
            <TextField
              label="To"
              variant="outlined"
              margin="normal"
              type="date"
              value={toDate1}
              onChange={(e) => setToDate1(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ width: "30%" }}
              inputProps={{
                min: fromDate1 || "",
              }}
              disabled={!fromDate1}
            />
            {/* <Button
            sx={{
              textTransform: "none",
              width: "20%",
              height: "40px",
              marginTop: "23px",
              backgroundColor: "#49a3ff",
              color: "#fff",
              "&:hover": { backgroundColor: "#49a3ff" },
            }}
            // onClick={handleFilterGraph1}
          >
            Apply
          </Button> */}
          </Box>
          <Divider style={{ marginTop: "10px", width: "110%" }} />
          <ReactECharts
            option={chartData}
            style={{ height: "407px", width: "490px" }}
            className="chart-container"
          />
        </CardContent>
      </div>
    </Card>
  );
};

// UserActivityChart Component (Graph 2)
const UserActivityChart = () => {
  const [chartOption, setChartOption] = useState({});
  const [fromDate2, setFromDate2] = useState(""); // State for 'From' date
  const [toDate2, setToDate2] = useState(""); // State for 'To' date

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dates2 = { fromDate2, toDate2 };
        const response = await dashBoardData2(dates2);
        const data = response.data.dashboardData2;

        const filteredData = data.filter(
          (d) => !["Saturday", "Sunday"].includes(d.day_of_week.trim())
        );

        const categories = filteredData.map((item) => item.day_of_week.trim());
        const totalUsers = filteredData.map((item) =>
          parseInt(item.total_users)
        );
        const totalServices = filteredData.map((item) =>
          parseInt(item.total_services_used)
        );

        setChartOption({
          tooltip: {
            trigger: "axis",
            backgroundColor: "#1E1E1E",
            borderColor: "#333",
            textStyle: { color: "#fff" },
            formatter: (params) => {
              return `
                <strong>${params[0].axisValue}</strong><br/>
                Total Users: <strong>${
                  totalUsers[params[0].dataIndex]
                }</strong><br/>
                Services Used: <strong>${
                  totalServices[params[0].dataIndex]
                }</strong>
              `;
            },
          },
          // legend: { data: ["Users"], bottom: 0 },
          xAxis: {
            type: "category",
            data: categories,
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: {
              interval: 0,
              fontSize: 12,
            },
          },

          yAxis: [{ type: "value", name: "No. of Users" }],
          series: [
            {
              name: "Users",
              type: "bar",
              data: totalUsers,
              barWidth: 20,
              itemStyle: { color: "#3b82f6" },
            },
          ],
        });
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
      }
    };

    fetchData();
  }, [fromDate2, toDate2]);

  return (
    <Card sx={{ maxWidth: "721px", minHeight: "470px" }}>
      <div className="chart-wrapper">
        <CardContent>
          <Typography variant="h6" gutterBottom>
            User Activity
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: -1,
            }}
          >
            <TextField
              label="From"
              variant="outlined"
              margin="normal"
              type="date"
              value={fromDate2}
              onChange={(e) => setFromDate2(e.target.value)}
              InputLabelProps={{
                shrink: true, // This keeps the label always above the input field
              }}
              sx={{
                width: "30%",
                height: "20px",
                "& input": {
                  appearance: "none", // Removes the default placeholder
                },
              }}
            />
            <TextField
              label="To"
              variant="outlined"
              margin="normal"
              type="date"
              value={toDate2}
              onChange={(e) => setToDate2(e.target.value)}
              InputLabelProps={{
                shrink: true, // This keeps the label always above the input field
              }}
              sx={{
                width: "30%",
                // height: "20px",
                "& input": {
                  appearance: "none", // Removes the default placeholder
                },
              }}
              inputProps={{
                min: fromDate2 || "",
              }}
              disabled={!fromDate2}
            />
            {/* <Button
            sx={{
              textTransform: "none",
              variant: "outlined",
              width: "20%",
              height: "40px",
              marginTop: "23px",
              backgroundColor: "#49a3ff",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#49a3ff",
              },
            }}
            // onClick={handleFilterGraph2}
          >
            Apply
          </Button> */}
          </Box>
          <Divider style={{ marginTop: "10px", width: "110%" }} />
          <ReactECharts
            option={chartOption}
            style={{ height: "400px", width: "475px" }}
            className="chart-container"
          />
        </CardContent>
      </div>
    </Card>
  );
};

//Graph 3
const ChartComponent = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const [projectCapability, setProjectCapability] = useState("");
  const [capabilities, setCapabilities] = useState([]);

  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState(""); // State for 'From' date
  const [toDate, setToDate] = useState(""); // State for 'To' date

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dates = { fromDate, toDate, capability_name: projectCapability };
        const response = await dashBoardData3(dates);
        let sortedData = response.data.dashboardData.sort(
          (a, b) => parseInt(b.total_tokens, 10) - parseInt(a.total_tokens, 10)
        ); // Sort data in descending order
        setDashboardData(sortedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fromDate, toDate, projectCapability]);

  useEffect(() => {
    const getCapabilitiesForDropDown = async () => {
      try {
        const response = await getAllCapabilities();
        setCapabilities(response.data);
      } catch (error) {
        console.error("Error fetching capabilities:", error);
      }
    };

    getCapabilitiesForDropDown();
  }, []);

  const serviceNames = dashboardData.map((item) => item.service_name);
  const totalTokens = dashboardData.map((item) =>
    parseInt(item.total_tokens, 10)
  );

  const options = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: (params) => {
        const { name, value } = params[0];
        return `<b>${name}</b><br/>Total Tokens Used: <b>${value}</b>`;
      },
    },
    grid: {
      left: "1%", // Increased space for Y-axis labels
      right: "5%",
      bottom: "5%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      min: 0,
      axisLabel: {
        fontSize: 11,
      },
      splitNumber: 4, // Show 4 intervals
    },
    yAxis: {
      type: "category",
      data: serviceNames,
      axisLabel: {
        fontSize: 12, // Reduced font size
        interval: 0, // Show all labels
        rotate: 0, // Rotate labels for better visibility
        formatter: (value) =>
          value.length > 15 ? value.slice(0, 15) + "..." : value, // Trim long labels
      },
      axisLine: { show: false }, // Removes the unwanted line
      axisTick: { show: false }, // Removes tick marks next to labels
    },
    series: [
      {
        name: "Total Tokens Used",
        type: "bar",
        data: totalTokens,
        barWidth: 14, // Slightly increased bar width
        barCategoryGap: "50%", // Ensure visible gap between bars
        itemStyle: {
          color: "#3b82f6",
          borderRadius: [0, 8, 8, 0], // Rounded right end of bars
        },
        emphasis: {
          itemStyle: {
            color: "#2563eb",
          },
        },
      },
    ],
  };

  return (
    <Card sx={{ maxWidth: "721px", minHeight: "470px", margin: "auto", p: 1 }}>
      <div className="chart-wrapper">
        <CardContent>
          <Grid2 container alignItems="center" justifyContent="space-between">
            <Grid2 item>
              <Typography variant="h6">
                Top 10 services
                <span
                  style={{
                    fontSize: "0.85rem",
                    marginLeft: "8px",
                    color: "#9C9C9C",
                    fontWeight: "bold",
                  }}
                >
                  Platform Usage
                </span>
              </Typography>
            </Grid2>
            <Grid2 item></Grid2>
          </Grid2>
          <FormControl sx={{ minWidth: 120, mt: -4, ml: 44 }} size="small">
            <InputLabel id="capability-name-label">Capability</InputLabel>
            <Select
              labelId="capability-name-label"
              value={projectCapability}
              onChange={(e) => setProjectCapability(e.target.value)}
              label="Capability"
            >
              {capabilities.map((item, index) => (
                <MenuItem key={index} value={item.capability_name}>
                  {item.capability_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: -2.5,
            }}
          >
            <TextField
              label="From"
              variant="outlined"
              margin="normal"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              InputLabelProps={{
                shrink: true, // This keeps the label always above the input field
              }}
              sx={{
                width: "30%",
                height: "20px",
                "& input": {
                  appearance: "none", // Removes the default placeholder
                },
              }}
            />
            <TextField
              label="To"
              variant="outlined"
              margin="normal"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              InputLabelProps={{
                shrink: true, // This keeps the label always above the input field
              }}
              sx={{
                width: "30%",
                // height: "20px",
                "& input": {
                  appearance: "none", // Removes the default placeholder
                },
              }}
              inputProps={{
                min: fromDate || "",
              }}
              disabled={!fromDate}
            />
            {/* <Button
            sx={{
              textTransform: "none",
              variant: "outlined",
              width: "20%",
              height: "40px",
              marginTop: "23px",
              backgroundColor: "#49a3ff",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#49a3ff",
              },
            }}
            // onClick={handleFilterTopServices}
          >
            Apply
          </Button> */}
          </Box>
          <Divider style={{ marginTop: "10px", width: "110%" }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 382,
            }}
          >
            {loading ? (
              <CircularProgress size={20} />
            ) : (
              <ReactECharts
                option={options}
                style={{ height: "400px", width: "475px" }}
                className="chart-container"
              />
            )}
          </Box>
        </CardContent>
      </div>
    </Card>
  );
};

// ChartComponent (4th graph)
const ServicesChart = () => {
  const [chartData, setChartData] = useState([]);
  const [fromDate4, setFromDate4] = useState(""); // State for 'From' date
  const [toDate4, setToDate4] = useState(""); // State for 'To' date

  useEffect(() => {
    const dates4 = { fromDate4, toDate4 };
    dashBoardData4(dates4)
      .then((response) => {
        processChartData(response.data.dashboardData2);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [fromDate4, toDate4]);

  // const handleFilterGraph4 = async () => {
  //   try {
  //     const dates4 = { fromDate4, toDate4 };
  //     const response4 = await dashBoardData4(dates4);
  //     processChartData(response4.data.dashboardData2);

  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const processChartData = (data) => {
    const aggregatedData = {};

    data.forEach((entry) => {
      const day = entry.day_of_week;
      if (!aggregatedData[day]) {
        aggregatedData[day] = {};
      }

      [1, 2, 3].forEach((index) => {
        const projectName = entry[`project_${index}_name`];
        if (projectName) {
          if (!aggregatedData[day][projectName]) {
            aggregatedData[day][projectName] = {
              users: 0,
              services: 0,
            };
          }
          aggregatedData[day][projectName].users += parseInt(
            entry[`top_project_${index}_users`] || 0
          );
          aggregatedData[day][projectName].services += parseInt(
            entry[`top_project_${index}_services`] || 0
          );
        }
      });
    });

    setChartData(aggregatedData);
  };

  const allProjects = [
    ...new Set(Object.values(chartData).flatMap((day) => Object.keys(day))),
  ];

  const projectColors = {};
  const colorPalette = ["#82ca9d", "#8884d8", "#ffc658", "#d45087", "#2ca02c"];
  allProjects.forEach((project, index) => {
    projectColors[project] = colorPalette[index % colorPalette.length];
  });

  const options = {
    tooltip: {
      trigger: "item",
      axisPointer: {
        type: "shadow",
      },
      barGap: "0%",
      formatter: function (params) {
        const projectName = params.seriesName.replace(" Services", "");
        const day = params.name;
        const value = params.value;

        if (params.seriesType === "bar") {
          return `${projectName}<br/>Day: ${day}<br/>Users: ${value}`;
        } else if (params.seriesType === "line") {
          return `${projectName}<br/>Day: ${day}<br/>Services: ${value}`;
        }
      },
    },
    Grid2: {
      bottom: "20%", // Make room for the legend at the bottom
    },
    legend: {
      data: [
        ...allProjects,
        ...allProjects.map((project) => `${project} Services`),
      ],
      orient: "horizontal",
      bottom: 0,
      type: "scroll", // Enable scrolling if many items
      padding: [5, 5],
      textStyle: {
        fontSize: 12,
      },
    },
    xAxis: {
      type: "category",
      data: Object.keys(chartData),
      axisTick: { show: false },
      splitLine: { show: false },
    },
    yAxis: [
      { type: "value", name: "No. of Users" },
      { type: "value", name: "Services Utilized" },
    ],
    axisLine: { show: false }, // Removes the unwanted line
    axisTick: { show: false },
    series: [
      ...allProjects.map((project) => ({
        name: project,
        type: "bar",
        stack: "users",
        barCategoryGap: "85%",
        barGap: "5%",
        data: Object.keys(chartData).map((day) =>
          chartData[day][project] ? chartData[day][project].users : 0
        ),
        itemStyle: { color: projectColors[project] },
        // barGap:"0%",
        emphasis: {
          focus: "series",
        },
      })),
      ...allProjects.map((project) => ({
        name: `${project} Services`,
        type: "line",
        yAxisIndex: 1,
        data: Object.keys(chartData).map((day) =>
          chartData[day][project] ? chartData[day][project].services : 0
        ),
        itemStyle: { color: projectColors[project] },
        emphasis: {
          focus: "series",
        },
      })),
    ],
  };

  return (
    <Card sx={{ maxWidth: "721px", minHeight: "470px" }}>
      <div className="chart-wrapper">
        <CardContent>
          <Typography variant="h6">
            Top 3 projects
            <span
              style={{
                fontSize: "0.85rem",
                marginLeft: "8px",
                color: "#9C9C9C",
                fontWeight: "bold",
              }}
            >
              User Activity
            </span>
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <TextField
              label="From"
              variant="outlined"
              margin="normal"
              type="date"
              value={fromDate4}
              onChange={(e) => setFromDate4(e.target.value)}
              InputLabelProps={{
                shrink: true, // This keeps the label always above the input field
              }}
              sx={{
                width: "30%",
                height: "20px",
                "& input": {
                  appearance: "none", // Removes the default placeholder
                },
              }}
            />
            <TextField
              label="To"
              variant="outlined"
              margin="normal"
              type="date"
              value={toDate4}
              onChange={(e) => setToDate4(e.target.value)}
              InputLabelProps={{
                shrink: true, // This keeps the label always above the input field
              }}
              sx={{
                width: "30%",
                // height: "20px",
                "& input": {
                  appearance: "none", // Removes the default placeholder
                },
              }}
              inputProps={{
                min: fromDate4 || "",
              }}
              disabled={!fromDate4}
            />
          </Box>
          <Divider style={{ marginTop: "10px", width: "110%" }} />
          <ReactECharts
            option={options}
            style={{ height: "400px", width: "475px" }}
            className="chart-container"
          />
        </CardContent>
      </div>
    </Card>
  );
};

export { TopServicesChart, UserActivityChart, ChartComponent, ServicesChart };
